export default "__VITE_ASSET__BsyGYBqa__"